import "../../components/map/map";
import http_helper from '../../base/http_helper'
import _map from "./_map";
import ("../../../styles/pages/map/map.css"); //Importando o css do Javascript
import _modal from './_modal'
import _chart from './_chart'
import _navigator_helper from "./_navigator_helper";
import FormFilter from '../../components/map/filter_marker_form/filter_marker_form'
import '../../components/offcanvas/offcanvas_menu'
import '../../components/map/layer_control/layer_control'

//import '../../../styles/components/map/dom.css' 
import ("../../../styles/components/map/map.css");
import _find_coords from "./_find_coords";

//alterando a url da pagina na abertura do modal
$(document).on('shown.bs.modal', '#station_prefix_modal', function(e){
    $("#hour_range_select").val(24)
    _navigator_helper.changeUrl("/sibh/mapa?station="+CURRENT_STATION_PREFIX, _navigator_helper.getCurrentUrl(), "station_show")
})

//alterando a url da pagina no fechamento do modal
$(document).on('hidden.bs.modal', '#station_prefix_modal', function(e){
    _navigator_helper.changeUrl("/sibh/mapa", _navigator_helper.getCurrentUrl(), "station_show")    
})

$(document).on('change', '#hour_range_select', function(){
    let period = this.value
    if(period != ""){
        _chart.generate({period: period, container: "#measurements_chart"})
    }
})

$(document).on('click', '.card.offcanvas .close', ()=>{
    OffcanvasMenu.hide()
})

// analisando se a URL da pagina muda
window.addEventListener('popstate', function () {
    let period = $("#hour_range_select").val()
    let search_params = _navigator_helper.getSearchParams()
    if(search_params.get("station")){ // tem parametro station
        if(!_modal.isOpen()){
            _modal.open()
        }
        let id = search_params.get("station")
        http_helper.request("/sibh/api/v1/station_prefixes", {station_prefix_ids: [id]}, 'GET').then(data=>{
            let station_prefix = data[0]
            CURRENT_STATION = station_prefix
            _modal.generateStationInformationTable(station_prefix)
            _modal.setTitle(station_prefix)
            _chart.generate({period: period, container: "#measurements_chart", station_type_id:CURRENT_STATION.station_type_id})
        })
    } else {
        if(_modal.isOpen()){
            _modal.close()
        }
    }
});


$(function(){
    window.CURRENT_STATION_PREFIX = undefined //auxiliar no controle do posto atualmente clicado
    window.CURRENT_STATION = undefined //auxiliar no controle do posto atualmente clicado

    //inicializando mapa
    let map_component = new MapComponent({
        container: "#map_container",
        map_id: 'map',
        zoom: 7,
        loading: {show:true, position: 'full'}, //top right, top-left, full
        basemap:{
            layers:[
                {title: 'default'}, {title: 'dark'}, {title:'satellite'}, {title:'navigation'}
            ]
        }
    })

    //gerando mapa
    map_component.generate()

    //configurando tamanho do mapa de acordo com o espaço disponivel na tela
    setMapContainerSize(map_component)
    window.addEventListener('resize', function () {
        setMapContainerSize(map_component)
    })    

    //buscando postos
    http_helper.request('/sibh/api/v1/station_prefixes/simplify', {}, 'GET').then(data=>{
        // adicionando markers no mapa
        map_component.addLayerToMap(_map.generateStationsMarkersGroup(data), 'markers')

        // adicionando para marker de localização no mapa
        map_component.addLayerToMap(new L.FeatureGroup(), 'location')

        //escondendo overlay de loading
        map_component.hideOverlay('full')
        
        //criando botão para abrir controle de camadas
        map_component.createDomElement('layer-control', 'topleft', '<i class="fas fa-layer-group text-white"></i>', {click:btnLayerControlHandler})

         //criando botão para abrir filtro de markers
        map_component.createDomElement('layer-control', 'topleft', '<i class="fas fa-filter text-white"></i>', {click:btnFilterMarkerHandler})
        
        //criando botão para abrir pesquisa de markers
        map_component.createDomElement('layer-control layer-control-find', 'topleft', '<i class="fas fa-search text-white"></i>', {click:btnSearchMarkerHandler})

        //inicializando filtro no offcanvas
        start_filter(map_component)

        //criando elemento para pesquisa de localização
        generateFindElement(map_component)
        
        //esta sendo necessário chamar o método invalidateSize mesmo sem a alteração do tamanho do mapa. Não me pergunte o porque kk (ja sei)
        map_component.getMap().invalidateSize();
    })
    //inicializando componente de controle de camadas
    startLayerControl(map_component)
    
    
})

async function setMapContainerSize(map_component){
    const HEADER_SIZE = $("#main_header").outerHeight();
    const FOOTER_SIZE = $("#main_footer").outerHeight();
    const BREADCRUMB_SIZE = $(".container-breadcrumb").outerHeight();
    $("section").removeClass("pb-2");
    $("section").addClass("p-0");
    $("section").css("height", (window.innerHeight - HEADER_SIZE - FOOTER_SIZE - BREADCRUMB_SIZE));
    $("section").css("min-height", (window.innerHeight - HEADER_SIZE - FOOTER_SIZE - BREADCRUMB_SIZE ));
    await new Promise(r => setTimeout(r, 100)); //necessário para o funcionamento
    map_component.getMap().invalidateSize()
}

const btnLayerControlHandler = _ =>{
    //definindo offcanvas que será controlado
    OffcanvasMenu.setElement("#card_layers_control")
    //escondendo outros offcanvas abertos atualmente
    OffcanvasMenu.hideAnyButElement()
    //abrindo offcanvas controlado
    OffcanvasMenu.toggle()
}
const btnFilterMarkerHandler = _ =>{
    OffcanvasMenu.setElement("#card_filter_markers")
    OffcanvasMenu.hideAnyButElement()
    OffcanvasMenu.toggle()
}

const btnSearchMarkerHandler = e =>{
    let elem = e.target
    $('.find-box-container').toggleClass('open')
}

const start_filter = map_component =>{
    //lista de campos que poderão ser filtrados. Lembrando que as informações devem estar disponíveis no markers, caso contrário o filtro não funcionará.
    //Ex: para o filtro de station_type, na construção do marker devem ser adicionadas as options 'station_type' e 'station_type_id'. 'Texto' e 'value' da option respecitivamente.
    let fields = ['station_type', 'city', 'ugrhi', 'station_owner', 'prefix']
    //inicializando component
    let formFilter = new FormFilter({
        container: '#card_filter_markers .card-body', //container do html do filtro
        markers: map_component._layers.markers.getLayers(), //lista de marcadores 
        filter_options_list: fields, //campos que poderam ser filtrados
        on_change_filter: true, //disparara evento 'filtered' no 'on change' dos form-controls,
        submit_button: {show:true, text:'Filtrar', class:'btn btn-outline-primary w-75'}, //opçoes do botão submit
        clear_button: {show:true, text:'<i class="fa fa-times">', class:'btn btn-outline-danger w-25'},
        show_total_results: true,
        title: {text:'<h3>Filtrar Postos</h3>', class:""}
    })
    //gerando formulário de filtro
    formFilter.generate()
    //Adicionando listerer ao evento de filtro do form_filter
    //O método 'removeLayers' não está conseguindo limpar os markers do cluster. Sendo assim, o cluster está sendo removido do mapa, e ourto sendo adicionado.
    $(document).on('filtered','.filter-marker-form',function(e,data){
        let markers = data.markers
        
        //transformando lista de markers em clusterGroup
        let marker_cluster = _map.markersToCluster(markers)
        
        //removendo a camada de cluster atualmente no mapa
        map_component.removeLayer('markers')
        
        //adicionando a nova camada cluster no mapa
        map_component.addLayerToMap(marker_cluster, 'markers')
        
        //tentando dar zoom nos markers do mapa (caso a camada esteja sem markers, vai dar erro)
        if(!map_component.zoomToLayer('markers')){
            
            //dando zoom no limite estadual caso não tenha nenhum marker, caso a camada não esteja carregada por qualquer motivo, vai dar erro
            if(!map_component.zoomToLayer('state_limit')){
                
                //retornando para um zoom default caso não encontre as camadas anteriores. Impossivel dar erro :)
                map_component._map.setView([-22.37, -48.55], 7)
            }
        }
    })
}

const startLayerControl =(map_component)=>{
    //definindo cores padrão das camadas que serão adicionadas
    let defaultStrokeColor, defaultFillColor;
    defaultStrokeColor = defaultFillColor = "#545454"

    //inicializando LayerControl
    let layer_control = new LayerControl(
        {
            map: map_component._map,
            container: '#card_layers_control .card-body',
            layers: [{
                title: 'Limite ugrhis',
                description: 'Limites das ugrhis do estado de São Paulo',
                controls:{
                    stroke: {title: 'Traçado',color: true,opacity: true, width:5,dcolor: defaultStrokeColor, dopacity:0.9},
                    fill: {title: 'Prenchimento',color:true, opacity: true, dcolor: defaultFillColor, dopacity:0.1},
                },
                id: "ugrhi_limit",
                limit_type: 'ugrhi',
                feature_filter:{
                    filterable:true,
                    field: 'nome',
                    id: 'codigo'
                },
                options:{
                    show:false
                },
                style:{
                    fill:{
                        color:defaultFillColor,
                        opacity:0.1,
                    },
                    stroke:{
                        color:defaultStrokeColor,
                        opacity:0.9,
                    },
                }
            },
            {
                title: 'Limite Estadual',
                description: 'Limites do estado de São Paulo',
                controls:{
                    stroke: {title: 'Traçado', color: true,opacity: true, width:5,dcolor: defaultStrokeColor, dopacity:0.9},
                    fill: {title: 'Preenchimento',color:true, opacity: true, dcolor: defaultFillColor, dopacity:0.1},
                },
                id: "state_limit",
                limit_type: 'state',
                url: layers_url['state_limit'],
                options:{
                    show:true
                },
                style:{
                    fill:{
                        color:defaultFillColor,
                        opacity:0.1,
                    },
                    stroke:{
                        color:defaultStrokeColor,
                        opacity:0.9,
                    },
                }
            }],
            filter_options: {placeholder: 'Filtrar camadas...', clear:true, only_add: true}
        }
    )

    //adicionando listeners para os eventos de carregamento das camadas
    $(document).on('loading.start', '.layer-control-component', (e,data)=>{
        //caso não tenha overlay na tela, exibir
        if(!map_component.isOverlayShowing()){
            //atualizando a posição do overlay caso esteja em outra
            map_component.setOverlayPosition('top-right')
            //exibindo overlay
            map_component.showOverlay('corner')
        }
    })
    
    $(document).on('loading.finish', '.layer-control-component', (e,data)=>{
        //camada carrega, removendo overlay
        map_component.hideOverlay('corner')
    })

    //gerando LayerControl
    layer_control.generate()
}
/**
 * Método simples pra criar a caixa de pesquisa
 * Futuramente até pode ser feito um componente com a mesma funcionalidade, levando em consideração que é sempre util uma caixa de pesquisa de localidade em mapas
 * @param {} map_component 
 */
const generateFindElement = (map_component) =>{
    //pegando instancia do botão 'procurar' no mapa. A caixa sempre aparecerá do lado direito do botão, não importando a ordem que ele seja carregado
    let elem = $('.layer-control-find')
    //pegando posição do elemento na tela
    let position = elem.offset()
    //criando a caixa de pesquisa e setando a posição de acordo
    $('body').append("<div class='find-box-container' style='left:"+(position.left+50)+"px;top:"+(position.top)+"px'><div class='find-box'><input type='text' value='-25.5689,-50.8978'></input><i class='fas fa-map-marker-alt text-danger mr-2 btn-location'></i><i class='fas fa-question-circle'></i></div><span class='error-span'>Coordenada inválida :(</span><span class='location-span'>Remover Localização</span></div>")
    tippy('.find-box-container .find-box .fa-question-circle', {
        content: "Formatos suportados:<br> <span class='text-info'>Latitude/Longitude:</span> 99999.999,8888.88<br><span class='text-danger'>DMS (N/W):</span> DD MM SS DD MM SS",
        zIndex: 999999999999,
        theme:'material',
        allowHTML: true
    });
    //adicionando listener ao pressionar teclas para verificar se a tecla 'ENTER' é pressionada
    $(document).on('keypress', '.find-box input',function(e){
        _find_coords.toDefaultState()
        if(e.originalEvent.code == "Enter"){
            //pesquisar coordenada
            if(_find_coords.validateCoords(this.value.trim())){
                //limpando qualquer outro marker no FeatureGroup location
                map_component.clearLayer('location')
                
                let coords = _find_coords.convertToDecimalDegreesObject(this.value.trim())
                //coordenada valida, convertendo para decimais (unica que o leaflet trabalha) e exibindo no mapa
                map_component.zoomToCoord(coords, false, 13)

                //adicionando o marker de localização no mapa através do FeatureGroup 'location'
                map_component.addLayerToFeature('location', _map.generateLocationMarker(coords.lat, coords.lng, 'Localização: '+coords.lat + ", " + coords.lng))

                //exibindo o botão para remover o marcador de location
                _find_coords.toLocatedState()
            } else {
                //coordenada incorreta, alterando o status do card para erro
                _find_coords.toIncorrectState()
            }
        }
    })
    //listener para click no botão de localização
    $(document).on('click', '.find-box .btn-location', function(){
        //limpando qualquer outro marker no FeatureGroup location
        map_component.clearLayer('location')

        let success = (data)=>{
            //pegando coordenadas vindas do navegador
            let coords = data.coords

            //zoom para as coordenadas
            map_component.zoomToCoord({lat:coords.latitude, lng:coords.longitude}, false, 15)

            //adicionando o marker de localização no mapa através do FeatureGroup 'location'
            map_component.addLayerToFeature('location', _map.generateLocationMarker(coords.latitude, coords.longitude, 'Sua localização'))

            //exibindo o botão para remover o marcador de location
            _find_coords.toLocatedState()
        }
        let error = (data) =>{
            //erro ao capturar coordenadas
        }
        //pegando coordenadas do usuário pelo navegador
        navigator.geolocation.getCurrentPosition(success,error, {});
    })

    $(document).on('click', '.find-box-container .location-span', ()=>{
        //limpando layer location
        map_component.clearLayer('location')

        //escondendo botão 'remover localização'
        _find_coords.removeLocatedState()
    })
}